import { useEffect, useState } from "react";

const read = () => {
    try {
        return localStorage.getItem("apf-theme") === "day" ? "day" : "night";
    } catch {
        return "night";
    }
};

const Sun = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
        <circle cx="12" cy="12" r="4" fill="currentColor" stroke="none" />
        <path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.3 5.3l2.1 2.1M16.6 16.6l2.1 2.1M5.3 18.7l2.1-2.1M16.6 7.4l2.1-2.1" />
    </svg>
);
const Moon = () => (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M14.5 3a9 9 0 1 0 6.5 15.3A8 8 0 0 1 14.5 3z" />
    </svg>
);

export default function ThemeToggle() {
    const [theme, setTheme] = useState(read);
    const day = theme === "day";

    useEffect(() => {
        document.documentElement.dataset.theme = theme;
        try {
            localStorage.setItem("apf-theme", theme);
        } catch {}
    }, [theme]);

    return (
        <button
            type="button"
            className={`theme-switch ${day ? "day" : ""}`}
            role="switch"
            aria-checked={day}
            data-testid="theme-toggle"
            aria-label={day ? "Passa alla versione notte" : "Passa alla versione giorno"}
            onClick={() => setTheme(day ? "night" : "day")}
        >
            <span className="switch-track" aria-hidden="true">
                <span className="switch-icon switch-icon-moon"><Moon /></span>
                <span className="switch-icon switch-icon-sun"><Sun /></span>
                <span className="switch-knob">{day ? <Sun /> : <Moon />}</span>
            </span>
            <span className="theme-label" data-testid="theme-label">
                {day ? "Giorno" : "Notte"}
            </span>
        </button>
    );
}
